import validator from 'validator';

export const isWebsite = (value: string) => {
    if (!value) {
        return undefined;
    }
    return validator.isURL(value || '') ? undefined : 'Invalid url';
};
